<template>
  <div class="back">
    <div class="zlfLogo">
      <img src="@/assets/img/login/logo-2.png" alt />
    </div>
    <div
      class="login_class"
      v-loading="loading"
      element-loading-text="拼命登录中。。。"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    }
  },
  components: {},
  mounted() {
    this.getLogin()
  },
  methods: {
    getLogin() {
      if (this.$route.query.token) {
        this.$store.dispatch('LoginToken', this.$route.query.token).then(() => {
          this.$router.push({ path: '/' })
        })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
  },
}
</script>
<style scoped>
.el-loading-mask {
  background-color: transparent !important;
}
.zlfLogo {
  width: 126px;
  height: 58px;
  position: absolute;
  top: 78px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.back {
  position: absolute;
  width: 100%;
  bottom: 0;
  top: 0;
  background: url(../../assets/img/login/back.png) no-repeat;
}
.login_class {
  width: 100%;
  margin-top: 300px;
}
.el-loading-spinner .circular {
  width: 55px !important;
  height: 55px !important;
}
.el-loading-spinner .el-loading-text {
  font-size: 20px !important;
}
</style>
